import { PlanRecordKeyTypes } from '@constants/plans'
import { PAYMENTS } from '@routes/path'
import { CheckoutRoutesTypes } from '@routes/path/payments'

import { setCheckoutData } from './checkoutData'

export const selectPlanAndGoToStep = ({
  recordKey,
  goToStep
}: {
  recordKey: PlanRecordKeyTypes
  goToStep: (stepRoute: CheckoutRoutesTypes) => void
}) => {
  if (!recordKey) {
    return
  }

  setCheckoutData({
    selectedRecordKey: recordKey
  })

  goToStep(PAYMENTS.CHECKOUT.CONFIGURE)
}
